
import React, { Component, Fragment } from 'react';
import { Table } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { ScaleLoader } from 'react-spinners';

import reportStore from '../../../stores/report-store';
import BottomNav from '../bottomNav';

class ActivityDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: '',
      amount: '',
      newJumperId: '',
      filterData: [],
      Isdata: false,
      isloading: true,
      jumperId: null,
    }
    this.loadJumperDetails = this.loadJumperDetails.bind(this);

    this.reportEvent = [
      { name: reportStore.getEventPrefix('jumperLogEvent'), func: this.handleJumperLogs }
    ];

  }

  componentDidMount = () => {
    let jumperDetails = localStorage.getItem('jumperDetails')
    if (jumperDetails != 'undefined') {
      jumperDetails = JSON.parse(jumperDetails)
      this.setState({
        jumperId: jumperDetails._id,
      })
    }
    this.loadJumperDetails();
    this.reportEvent.forEach((evnt) => reportStore.on(evnt.name, evnt.func));
    // reportStore.on(reportStore.getEventPrefix('jumperLogEvent'), this.handleJumperLogs)
  }
  componentWillUnmount = () => {
    this.reportEvent.forEach((evnt) => reportStore.removeListener(evnt.name, evnt.func));

  }

  handleJumperLogs = (logs) => {
    this.setState({ filterData: logs, Isdata: true });
    setTimeout(() => {
      this.setState({
        isloading: false
      })
    }, 3000)
  }

  loadJumperDetails() {
    var startDate = '';
    var endDate = '';
    let sDate = new Date();
    sDate = sDate.setHours(0, 0, 0, 0);
    startDate = new Date(sDate);
    startDate = startDate.toISOString('yyyy-mm-ddThh:mm:ss.000Z');

    let eDate = new Date();
    eDate = eDate.setHours(23, 59, 59, 999);
    endDate = new Date(eDate);
    endDate = endDate.toISOString('yyyy-mm-ddThh:mm:ss.000Z');

    this.setState({
      filterData: [],
      Isdata: false,
      isloading: true
    }, (isModalOpen) => {
      reportStore.GetDateOfLastZeroPostedBalance(this.state.jumperId)
        .then(startDate => {
          reportStore.GetJumperLogs(startDate, endDate, this.state.jumperId);
        })
    });
  }

  checkForNegatives = (price) => {
    let priceCell = (price < 0) ?
      {
        value: `($${Math.abs(price).toFixed(2)})`
      } :
      {
        value: `$${price.toFixed(2)}`
      }

    if (price < 0) {
      return <span style={{ color: 'red' }}> {priceCell.value}</span>;
    }
    return priceCell.value;
  }

  filterData = () => {
    let filterOutput = [];
    let jumperArray = [];
    let summaryArray = [];

    if (this.state.Isdata === true) {
      this.filterDataArray = this.state.filterData;
      for (var sortItem in this.filterDataArray) {
        if (sortItem !== 'summary') {
          jumperArray.push({ label: this.DateConvert(sortItem), type: 'date', jumperStatement: [], summary: [] })
          var statments = this.filterDataArray[sortItem];
          for (var item in statments) {
            filterOutput = [];
            var logArray = statments[item];
            for (var items in logArray) {
              var desc = logArray[items];
              let JumperInfo = [];

              if (desc.jumperIds !== undefined) {
                var otherJumper = desc.jumperIds;
                for (var oitem in otherJumper) {
                  var name = otherJumper[oitem].jumperId.firstname + ' ' + otherJumper[oitem].jumperId.lastname;
                  JumperInfo.push({ jumperName: name })
                }
              }

              var date = new Date(desc.createdAt);
              var localDate = '';
              var type = '';
              if (desc.type != undefined) {
                if (desc.type === "aff main") {
                  type = desc.type + ' ' + desc.level;
                }
                else {
                  type = desc.type;
                }
              }
              else {
                type = desc.jumpType;
              }

              if (desc.createdAt !== undefined) {
                //localDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                localDate = date.getFullYear() + "-" + this.formatDate(date.getMonth() + 1) + "-" + this.formatDate(date.getDate()) + " " + this.formatDate(date.getHours()) + ":" + this.formatDate(date.getMinutes());
              }
              else {
                var date = new Date(desc.date);
                localDate = date.getFullYear() + "-" + this.formatDate(date.getMonth() + 1) + "-" + this.formatDate(date.getDate()) + " " + this.formatDate(date.getHours()) + ":" + this.formatDate(date.getMinutes());
              }

              filterOutput.push({ id: desc._id, type: type, price: desc.price, amount: desc.amount, date: localDate, JumpType: item, JumperArray: JumperInfo, loadNum: desc.loadNum, memo: desc.memo, transactionType: desc.transactionType, description: desc.description })

            }
            if (logArray.length > 0) {
              jumperArray.push({ label: item, jumperStatement: filterOutput, summary: summaryArray })
            }
          }
          jumperArray.push({ label: 'EndDayBalance', value: statments.endDayBalance, jumperStatement: [], summary: [] })
          //sortedArray.push(jumperArray);
        }
      }
    }
    // return filterOutput;
    return jumperArray;
  }

  formatDate(input) {
    if (input.toString().length == 1) {
      return '0' + input;
    }
    else {
      return input;
    }
  }


  renderJumper = (items) => {
    let { classes } = this.props;
    return items.jumperStatement.map((item, index) => {
      return (
        <Fragment key={`jumper${index}`}>
          <tr key={`jumperlogsrow${index}`}>
            <td
              key={`jumperlogscolumn1${index}`}
            >
              {item.type}
            </td>

            <td
              key={`jumperlogscolumn2${index}`}
            >
              {item.date}
            </td>

            <td
              key={`jumperlogscolumn3${index}`}
            >
              {item.price != undefined ? this.checkForNegatives(item.price) : ''}
              {item.amount != undefined ? this.checkForNegatives(item.amount) : ''}
            </td>

            <td
              key={`jumperlogscolumn4${index}`}
            >
              {item.loadNum != undefined ? item.loadNum : ''}
            </td>
          </tr>

          {
            item.type.trim() === "charge" && item.memo &&
            <tr
              key={`jumperlogsMemorow${index}`}>
              <td
                colSpan={4}
                key={`jumperlogsMemocolumnr${index}`}
                style={{ paddingLeft: '20px' }}
              >
                {item.memo}
              </td>
            </tr>
          }

          {
            item.type.trim() === "transfer" &&
            <tr
              key={`jumperlogsDescrow${index}`}>
              <td
                colSpan={4}
                key={`jumperlogsDesccolumnr${index}`}
                style={{ paddingLeft: '20px' }}
              >
                {item.description && "Description : " + item.description}

                {
                  item.memo && item.description &&
                  <br />
                }

                {item.memo !== "" && "Memo : " + item.memo}
              </td>
            </tr>
          }

          {
            item.type.trim() == "miscellaneous" && item.memo &&
            <tr
              key={`miscellaneouscrow${index}`}>
              <td
                colSpan={4}
                key={`miscellaneous${index}`}
                style={{ paddingLeft: '20px' }}
              >
                {item.memo}
              </td>
            </tr>
          }

          {
            item.type.trim() == "adjustment" && item.memo &&
            <tr
              key={`adjustmentrow${index}`}>
              <td
                colSpan={4}
                key={`adjustment${index}`}
                style={{ paddingLeft: '20px' }}
              >
                {item.memo}
              </td>
            </tr>
          }

          {
            item.JumpType === "funJumps"
              ?
              this.renderOtherJumper(item.JumperArray, index)
              :
              ''
          }
        </Fragment>
      )
    })
  }

  DateConvert = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  renderOtherJumper = (JumperArray, index) => {
    let { classes } = this.props;
    var otherJumpers = "";

    JumperArray.map((item) => {
      if (otherJumpers === "") {
        otherJumpers = item.jumperName;
      }
      else {
        otherJumpers = otherJumpers + ', ' + item.jumperName;
      }
    })

    return (
      <tr key={`otherjumperRow${index}`}>
        <td
          colSpan={4}
          key={`otherjumpercolumn${index}`}
          style={{ paddingLeft: '20px' }}
        >
          {otherJumpers}
        </td>
      </tr>
    )
  }

  render() {
    // console.log("CARSD: ", this.state.cardsArray);

    let isloading=this.state.isloading;
    return (

      <div className="col bodyView" style={{ height: '95vh' }}>
        {
          isloading ? (
            <div style={{ position: 'absolute', left: '48%', top: '40%', zIndex: '999999' }}>
              <div className='sweet-loading'>
                <ScaleLoader
                  height={35}
                  width={8}
                  margin={'2px'}
                  radius={2}
                  color={'#123abc'}
                  loading={this.state.isloading}
                />
                <p>Please wait...</p>
              </div>
            </div>
          ) : (
              <div className="details-container">
                {/* <div className="btn-container">
                  <CardButton jumperId={this.state.jumperId}/>
                </div> */}
                <Table striped style={{ borderTopStyle: "hidden" }}>
                  <thead>
                    <tr>
                      <th>Jump Type</th>
                      <th>Date</th>
                      <th>Price</th>
                      <th>Load Num</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      isloading ? null : (
                        this.filterData().map((row, index) => {
                          return (
                            <Fragment key={`RowHeader${index}`}>
                              <tr >
                                {
                                  row.label !== 'EndDayBalance' ?
                                    <th scope="row" colSpan="4" style={{
                                      fontSize: row.type === 'date' ? '24px' : '',
                                      textIndent: row.type === 'date' ? '-0.4rem' : ''
                                    }}
                                    >
                                      {row.label.toLocaleUpperCase()}
                                    </th>
                                    :
                                    <th scope="row" colSpan="4">
                                      {row.label.toLocaleUpperCase()} : {this.checkForNegatives(row.value)}
                                    </th>
                                }
                              </tr>
                              {this.renderJumper(row)}
                            </Fragment>
                          )
                        })
                      )
                    }

                  </tbody>
                </Table>

                <Link to="/daily-activity">
                  Back
                </Link>

              </div>
            )}
        <BottomNav history={this.props.history} componentToRender={0} />
      </div>
    );
  }
}

export default withRouter(ActivityDetails);
